import axios from "axios";
import axiosErrorInterceptor from "./axiosErrorInterceptor";

const httpCognito = axios.create({
  baseURL: `https://${process.env.REACT_APP_AUTH_DOMAIN}`,
  // headers: {
  //   "Content-Type": "application/x-www-form-urlencoded",
  //   // "Access-Control-Allow-Origin": "*",
  //   // "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
  //   // "Access-Control-Allow-Credentials": true,
  // },
});

httpCognito.interceptors.response.use(
  (response) => response,
  (error) => axiosErrorInterceptor(error)
);

export default httpCognito;